import html2pdf from 'html2pdf.js';

const handleConvertToPDF_V2 = async ({
  lang = 'ar',
  elementId = 'printable-content',
  fileName = 'document.pdf'
}) => {
  const originalElement = document.getElementById(elementId);
  
  if (!originalElement) {
    console.error(`Element with ID "${elementId}" not found`);
    return;
  }

   const pdfContainer = document.createElement('div');
  pdfContainer.style.position = 'absolute';
  pdfContainer.style.left = '-9999px';
  pdfContainer.style.width = '794px';  
  pdfContainer.style.backgroundColor = '#ffffff';
  pdfContainer.style.padding = '0';  
  document.body.appendChild(pdfContainer);

   const contentClone = originalElement.cloneNode(true);
  
   contentClone.style.height = 'auto';
  contentClone.style.maxHeight = 'none';
  contentClone.style.overflow = 'visible';
  contentClone.style.backgroundColor = '#ffffff';
  contentClone.style.padding = '8px';  
  contentClone.style.width = '100%';
  
   const scrollableElements = contentClone.querySelectorAll('[class*="overflow-y"], [class*="overflow-x"], [style*="overflow"]');
  scrollableElements.forEach(el => {
    el.style.height = 'auto';
    el.style.maxHeight = 'none';
    el.style.overflow = 'visible';
    el.style.backgroundColor = '#ffffff';
    el.style.width = '100%';
  });

   const tables = contentClone.querySelectorAll('table, [class*="table"]');
  tables.forEach(table => {
    table.style.height = 'auto';
    table.style.maxHeight = 'none';
    table.style.overflow = 'visible';
    table.style.backgroundColor = '#ffffff';
    table.style.width = '100%';  
    table.style.borderCollapse = 'collapse';
    table.style.margin = '0';
    
     const tableElements = table.querySelectorAll('tr, td, th, thead, tbody');
    tableElements.forEach(el => {
      el.style.height = 'auto';
      el.style.maxHeight = 'none';
      el.style.overflow = 'visible';
    });
    
     const cells = table.querySelectorAll('td, th');
    cells.forEach(cell => {
      cell.style.padding = '4px 6px';  
    });
  });

   const styles = {
    width: '100%',
    margin: '0',
    padding: '8px',  
    direction: lang === 'ar' ? 'rtl' : 'ltr',
    textAlign: lang === 'ar' ? 'right' : 'left',
    fontSize: '12pt',
    lineHeight: '1.4',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif',
    overflow: 'visible',
    backgroundColor: '#ffffff',
    color: '#000000'
  };

  Object.assign(contentClone.style, styles);

  // Optimize images
  const images = contentClone.getElementsByTagName('img');
  for (let img of images) {
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.display = 'block';
    img.style.marginLeft = lang === 'ar' ? 'auto' : '0';
    img.style.marginRight = lang === 'ar' ? '0' : 'auto';
  }

   pdfContainer.appendChild(contentClone);

   const options = {
    filename: fileName,
    margin: [5, 5, 5, 5], // Minimal margins
    image: { type: 'jpeg', quality: 1 },
    html2canvas: {
      scale: 5,
      useCORS: true,
      letterRendering: true,
      scrollY: 0,
      logging: false,
      imageTimeout: 15000,
      removeContainer: true,
      backgroundColor: '#ffffff',
      onclone: (document) => {
        const content = document.querySelector(`#${elementId}`);
        if (content) {
          content.style.height = 'auto';
          content.style.overflow = 'visible';
          content.style.direction = lang === 'ar' ? 'rtl' : 'ltr';
          content.style.textAlign = lang === 'ar' ? 'right' : 'left';
          content.style.backgroundColor = '#ffffff';
          content.style.padding = '8px'; // Small padding
          content.style.width = '100%'; // Full width
          
          // Ensure all tables are full width
          const tables = content.querySelectorAll('table');
          tables.forEach(table => {
            table.style.width = '100%';
            table.style.borderCollapse = 'collapse';
            table.style.margin = '0';
            
            // Adjust table headers
            const headers = table.querySelectorAll('th');
            headers.forEach(header => {
              header.style.backgroundColor = '#ffffff';
              header.style.padding = '4px 6px';
              header.style.borderBottom = '1px solid #ddd';
            });
            
            // Adjust table cells
            const cells = table.querySelectorAll('td');
            cells.forEach(cell => {
              cell.style.padding = '4px 6px';
              cell.style.borderBottom = '1px solid #eee';
            });
          });
          
          // Remove any unnecessary margins or paddings from containers
          const containers = content.querySelectorAll('div');
          containers.forEach(container => {
             if (parseFloat(window.getComputedStyle(container).padding) > 10) {
              container.style.padding = '8px';
            }
            container.style.margin = '0';
          });
        }
        
        // Ensure white background for entire page
        document.body.style.backgroundColor = '#ffffff';
        document.documentElement.style.backgroundColor = '#ffffff';
      }
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait',
      compress: true,
      precision: 16,
      direction: lang === 'ar' ? 'rtl' : 'ltr',
      putOnlyUsedFonts: true,
      background: '#ffffff'
    },
    pagebreak: {
      mode: ['avoid-all', 'css', 'legacy'],
      before: '.page-break-before',
      after: '.page-break-after',
      avoid: ['tr', 'td', '.no-break']
    }
  };

  try {
     const imagePromises = Array.from(images).map(img => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
          setTimeout(resolve, 3000);
        }
      });
    });
    
    await Promise.all(imagePromises);

     await html2pdf()
      .from(contentClone)
      .set(options)
      .save();

  } catch (error) {
    console.error('Error converting to PDF:', error);
  } finally {
     if (document.body.contains(pdfContainer)) {
      document.body.removeChild(pdfContainer);
    }
  }
};

export default handleConvertToPDF_V2;